import React, { useEffect, useState } from "react";
import Logo from "./Logo";

const NAV_LINKS = [
  { label: "Learn", href: "#certifications", title: "11 certifications" },
  { label: "Build", href: "#arena", title: "Innovation Arena" },
  { label: "Hire", href: "#talent", title: "AI talent pipeline" },
  { label: "Invest", href: "#beyond", title: "Pitch Hub" },
  { label: "Adopt", href: "#adopt", title: "AI Adoption Services" },
  { label: "Method", href: "#method", title: "How we ship" },
  { label: "Industries", href: "#industries", title: "Where we deploy" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="primary-nav"
      className={`sticky top-0 z-40 transition-all ${
        scrolled
          ? "backdrop-blur-md border-b hairline"
          : "border-b border-transparent"
      }`}
      style={{ background: scrolled ? "rgba(250,250,247,0.78)" : "transparent" }}
    >
      <div className="container-edge h-[72px] flex items-center justify-between">
        {/* Left: logo + tagline */}
        <a href="#top" className="flex items-center gap-4" data-testid="nav-logo">
          <Logo size={36} />
          <span className="hidden md:inline mono-label" style={{ letterSpacing: "0.16em" }}>
            Learn. Build. Hire. Invest.
          </span>
        </a>

        {/* Center: nav links */}
        <ul className="hidden lg:flex items-center gap-7 text-[13.5px] text-ink-secondary">
          {NAV_LINKS.map((l) => (
            <li key={l.label}>
              <a
                href={l.href}
                title={l.title}
                className="link-underline hover:text-ink transition-colors"
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        {/* Right: CTAs */}
        <div className="hidden md:flex items-center gap-4">
          <a href="#enquiry" className="btn-primary" data-testid="nav-enquire-btn">
            Enquire
          </a>
        </div>

        {/* Mobile menu button */}
        <button
          className="md:hidden inline-flex items-center justify-center w-10 h-10 border hairline-strong rounded-sm"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          <span className="block w-4 h-px bg-ink relative">
            <span
              className="block w-4 h-px bg-ink absolute"
              style={{ top: open ? 0 : -5, transform: open ? "rotate(45deg)" : "none", transition: "all 200ms" }}
            />
            <span
              className="block w-4 h-px bg-ink absolute"
              style={{ top: open ? 0 : 5, transform: open ? "rotate(-45deg)" : "none", transition: "all 200ms" }}
            />
          </span>
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden border-t hairline bg-canvas/95 backdrop-blur" data-testid="nav-mobile-menu">
          <ul className="container-edge py-4 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  className="block py-2 text-[15px] text-ink"
                  onClick={() => setOpen(false)}
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#enquiry"
                className="btn-primary mt-2 w-full"
                onClick={() => setOpen(false)}
                data-testid="nav-mobile-enquire-btn"
              >
                Enquire
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}
